import texts from '../locale';

export const getMeaning = key => {
  return key.split('.').reduce((o, i) => (o ? o[i] : key), texts);
};
